import { Route, Routes } from 'react-router-dom';
import { Details } from './Details';
import { History } from './History';

export const AccountingSettlement = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<History />} />
        <Route path="/:reportId" element={<Details />} />
      </Routes>
    </>
  );
};
